import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import metadata from './block.json';
import { getWrapperClasses } from './styles';

/**
 * The wrapper before Block spacing was serialized.
 *
 * blockGap used to be a declared support that nothing read, so a card with a
 * spacing value saved exactly the same markup as one without. Now that
 * styles.js writes `--brandy-team-member-gap`, those cards would fail
 * validation on load; this reproduces the old wrapper so they stay valid and
 * pick up the property the next time they are edited.
 *
 * Frozen on purpose — it must keep emitting the old markup even as
 * getWrapperStyles() grows. Only the class list is shared, because that half
 * did not change.
 *
 * @param {Object} attributes Block attributes.
 * @return {Object} React style object.
 */
function getWrapperStylesV1(attributes) {
  const { avatarSize, avatarRingColor, avatarRingWidth } = attributes;

  const styles = {
    '--brandy-avatar-size': `${avatarSize}px`,
    '--brandy-avatar-ring-width': `${avatarRingWidth}px`,
  };

  if (avatarRingColor) {
    styles['--brandy-avatar-ring-color'] = resolvePresetValueV1(avatarRingColor);
  }

  return styles;
}

/**
 * Preset resolution as it stood for v1, kept local for the same reason.
 *
 * @param {string} value Stored attribute value.
 * @return {string} CSS value.
 */
function resolvePresetValueV1(value) {
  if (typeof value !== 'string' || !value.startsWith('var:')) {
    return value;
  }

  return `var(--wp--${value.slice(4).replace(/\|/g, '--')})`;
}

const v1 = {
  attributes: metadata.attributes,
  supports: metadata.supports,
  save({ attributes }) {
    const blockProps = useBlockProps.save({
      className: getWrapperClasses(attributes),
      style: getWrapperStylesV1(attributes),
    });

    const innerBlocksProps = useInnerBlocksProps.save(blockProps);

    return <div {...innerBlocksProps} />;
  },
};

export default [v1];
